import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BaseDataService, HttpResponsesHandlersFactory } from "@bbwt/modules/data-service";
import { HtmlRenderingService } from "@main/reporting.v3/core/rendering/html-rendering.service";
import { IControlSetPdfTemplateSettings } from "@main/reporting.v3/widget.control-set/widget-control-set.models";
import {
    WidgetControlSetAuxiliaryService
} from "@main/reporting.v3/widget.control-set/api/widget-control-set-auxiliary.service";
import { JsReportConfiguration } from "@main/pdf-exporting/js-report/js-report.models";
import { PdfExportSettings } from "@main/reporting.v3/core/reporting-models";

@Injectable()
export class WidgetControlSetPdfExportingService extends BaseDataService {
    readonly url: string = "api/reporting3/widget/control-set/data";

    constructor(private readonly widgetControlSetAuxiliaryService: WidgetControlSetAuxiliaryService,
                private readonly htmlRenderingService: HtmlRenderingService,
                http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
        super(http, handlersFactory);
    }

    public async requestPdfExport(widgetSourceId: string, settings: PdfExportSettings): Promise<string> {
        return this.httpPost(`${widgetSourceId}/pdf-export`, settings);
    }

    public async getPdfConfiguration(settings: IControlSetPdfTemplateSettings): Promise<JsReportConfiguration> {
        const template: string = this.getHtmlContent(settings);
        const cssRules: string = this.getCssRules();

        const footerTemplate: string = this.getFooterTemplate();
        const footerCssRules: string = this.getFooterCssRules();

        return {
            template: template,
            cssRules: cssRules,
            footerTemplate: footerTemplate,
            footerCssRules: footerCssRules,
            marginTop: 20,
            marginLeft: 20,
            marginRight: 20,
            marginBottom: 40,
        };
    }


    private getHtmlContent(settings: IControlSetPdfTemplateSettings): string {
        if (!settings.template || !settings.controlSetFiltersTemplate) return "";

        const parser: DOMParser = new DOMParser();
        const doc: Document = parser.parseFromString(settings.template, "text/html");

        // Add PDF view container class to widget container class list.
        doc.querySelector(this.widgetContainerSelector)?.classList?.add("pdf-view");

        const controlSetFilters: HTMLElement = doc.querySelector(this.controlSetFiltersSelector);
        if (!controlSetFilters) return "";

        // Replace web control-set content with pdf view control-set content.
        controlSetFilters.innerHTML = settings.controlSetFiltersTemplate;

        return doc.body?.innerHTML;
    }

    private getCssRules(): string {
        const containerCssRules: string = this.htmlRenderingService.getCssRules(this.widgetContainerSelector);
        const bodyCssStyles: string = this.htmlRenderingService.getCssRules("body");
        return `${containerCssRules}\n${bodyCssStyles}`;
    }


    private getFooterTemplate(): string {
        return "<div class='widget-control-set-footer pdf-view'>Page <span class='pageNumber'>" +
            "</span> of <span class='totalPages'></span></div>";
    }

    private getFooterCssRules(): string {
        return this.htmlRenderingService.getCssRules(".widget-control-set-footer.pdf-view");
    }


    private get widgetContainerSelector(): string {
        return `.${this.widgetControlSetAuxiliaryService.widgetContainerClass}`;
    }

    private get controlSetFiltersSelector(): string {
        return `.${this.widgetControlSetAuxiliaryService.controlSetFiltersClass}`;
    }
}